import { Traveler } from '../traveler.interface';

export class MakeQuoteBodyRequest {
  private destinations: number[];
  private policyDestinationType: number;
  private type: number;
  private fromDate: string;
  private toDate: string;
  private processType: number;
  private platform: number;
  private agentSaleNumberId: string | null;
  private distributorUserId: string;
  private organizationId: string;
  private travelers: Omit<Traveler, 'productCover'>[];
  private calculatedPrice: number;
  private selectedInsuredAmountId: number;
  private policyGroupId: number;
  private couponId: number;
  private isMobile: boolean;
  private payeeId: number;
  private owner: Owner;
  private isFirstQuote: boolean;
  private quoteId: number;
  private leadId: string;
  private referredById: number;
  private cgMidDesign: string;
  private paymentSuccessURL: string;
  private paymentErrorURL: string;
  private stateId: number;
  private brokerFee: number;
  private associationId: string | null;
  private siteUserId: string | null;
  private agentWiseLeadId: string;
  private selectedExcessLevelId: number;
  private amtTripDurationId: number;
  private cfarApproval: boolean;
  private billingCurrencyISO: string;
  private campaignId: number;
  private accumulationAreaId: number;
  private mainCountryId: number;
  private appPartnersId: number;
  private companyId: number;
  private areaId: number;
  private isAnnual: boolean;
  private singleTripDuration: number;
  private isBusinessClass: boolean;
  private uwRequired: boolean;
  private declaredCovid19Risk: boolean;
  private basicQuoteDetailsId: string | null;
  private site: number;
  private channel: number;
  private questionnaireId: number;

  public getDestinations(): number[] {
    return this.destinations;
  }

  public setDestinations(value: number[]): void {
    this.destinations = [...value];
  }

  public getChannel(): number {
    return this.channel;
  }

  public setChannel(value: number): void {
    this.channel = value;
  }

  public getSite(): number {
    return this.site;
  }

  public setSite(value: number): void {
    this.site = value;
  }

  public getBasicQuoteDetailsId(): string | null {
    return this.basicQuoteDetailsId;
  }

  public setBasicQuoteDetailsId(value: string | null): void {
    this.basicQuoteDetailsId = value;
  }

  public getDeclaredCovid19Risk(): boolean {
    return this.declaredCovid19Risk;
  }

  public setDeclaredCovid19Risk(value: boolean): void {
    this.declaredCovid19Risk = value;
  }

  public getUwRequired(): boolean {
    return this.uwRequired;
  }

  public setUwRequired(value: boolean): void {
    this.uwRequired = value;
  }

  public getIsBusinessClass(): boolean {
    return this.isBusinessClass;
  }

  public setIsBusinessClass(value: boolean): void {
    this.isBusinessClass = value;
  }

  public getSingleTripDuration(): number {
    return this.singleTripDuration;
  }

  public setSingleTripDuration(value: number): void {
    this.singleTripDuration = value;
  }

  public getIsAnnual(): boolean {
    return this.isAnnual;
  }

  public setIsAnnual(value: boolean): void {
    this.isAnnual = value;
  }

  public getAreaId(): number {
    return this.areaId;
  }

  public setAreaId(value: number): void {
    this.areaId = value;
  }

  public getCompanyId(): number {
    return this.companyId;
  }

  public setCompanyId(value: number): void {
    this.companyId = value;
  }

  public getAppPartnersId(): number {
    return this.appPartnersId;
  }

  public setAppPartnersId(value: number): void {
    this.appPartnersId = value;
  }

  public getMainCountryId(): number {
    return this.mainCountryId;
  }

  public setMainCountryId(value: number): void {
    this.mainCountryId = value;
  }

  public getAccumulationAreaId(): number {
    return this.accumulationAreaId;
  }

  public setAccumulationAreaId(value: number): void {
    this.accumulationAreaId = value;
  }

  public getCampaignId(): number {
    return this.campaignId;
  }

  public setCampaignId(value: number): void {
    this.campaignId = value;
  }

  public getBillingCurrencyISO(): string {
    return this.billingCurrencyISO;
  }

  public setBillingCurrencyISO(value: string): void {
    this.billingCurrencyISO = value;
  }

  public getCfarApproval(): boolean {
    return this.cfarApproval;
  }

  public setCfarApproval(value: boolean): void {
    this.cfarApproval = value;
  }

  public getAmtTripDurationId(): number {
    return this.amtTripDurationId;
  }

  public setAmtTripDurationId(value: number): void {
    this.amtTripDurationId = value;
  }

  public getExcessLevelId(): number {
    return this.selectedExcessLevelId;
  }

  public setExcessLevelId(value: number): void {
    this.selectedExcessLevelId = value;
  }

  public getAgentWiseLeadId(): string {
    return this.agentWiseLeadId;
  }

  public setAgentWiseLeadId(value: string): void {
    this.agentWiseLeadId = value;
  }

  public getSiteUserId(): string | null {
    return this.siteUserId;
  }

  public setSiteUserId(value: string | null): void {
    this.siteUserId = value;
  }

  public getAssociationId(): string | null {
    return this.associationId;
  }

  public setAssociationId(value: string | null): void {
    this.associationId = value;
  }

  public getPolicyDestinationType(): number {
    return this.policyDestinationType;
  }

  public setPolicyDestinationType(value: number): void {
    this.policyDestinationType = value;
  }

  public getType(): number {
    return this.type;
  }

  public setType(value: number): void {
    this.type = value;
  }

  public getFromDate(): string {
    return this.fromDate;
  }

  public setFromDate(value: string): void {
    this.fromDate = value;
  }

  public getToDate(): string {
    return this.toDate;
  }

  public setToDate(value: string): void {
    this.toDate = value;
  }

  public getProcessType(): number {
    return this.processType;
  }

  public setProcessType(value: number): void {
    this.processType = value;
  }

  public getPlatform(): number {
    return this.platform;
  }

  public setPlatform(value: number): void {
    this.platform = value;
  }

  public getAgentSaleNumberId(): string | null {
    return this.agentSaleNumberId;
  }

  public setAgentSaleNumberId(value: string | null): void {
    this.agentSaleNumberId = value;
  }

  public getDistributorUserId(): string {
    return this.distributorUserId;
  }

  public setDistributorUserId(value: string): void {
    this.distributorUserId = value;
  }

  public getOrganizationId(): string {
    return this.organizationId;
  }

  public setOrganizationId(value: string): void {
    this.organizationId = value;
  }

  public getTravelers(): Omit<Traveler, 'productCover'>[] {
    return this.travelers;
  }

  public setTravelers(value: Omit<Traveler, 'productCover'>[]): void {
    this.travelers = value;
  }

  public getCalculatedPrice(): number {
    return this.calculatedPrice;
  }

  public setCalculatedPrice(value: number): void {
    this.calculatedPrice = value;
  }

  public getPolicyGroupId(): number {
    return this.policyGroupId;
  }

  public setPolicyGroupId(value: number): void {
    this.policyGroupId = value;
  }

  public getCouponId(): number {
    return this.couponId;
  }

  public setCouponId(value: number): void {
    this.couponId = value;
  }

  public getIsMobile(): boolean {
    return this.isMobile;
  }

  public setIsMobile(value: boolean): void {
    this.isMobile = value;
  }

  public getPayeeId(): number {
    return this.payeeId;
  }

  public setPayeeId(value: number): void {
    this.payeeId = value;
  }

  public getOwner(): Owner {
    return this.owner;
  }

  public setOwner(value: Owner): void {
    this.owner = value;
  }

  public getIsFirstQuote(): boolean {
    return this.isFirstQuote;
  }

  public setIsFirstQuote(value: boolean): void {
    this.isFirstQuote = value;
  }

  public getQuoteId(): number {
    return this.quoteId;
  }

  public setQuoteId(value: number): void {
    this.quoteId = value;
  }

  public getLeadId(): string {
    return this.leadId;
  }

  public setLeadId(value: string): void {
    this.leadId = value;
  }

  public getReferredBy(): number {
    return this.referredById;
  }

  public setReferredBy(value: number): void {
    this.referredById = value;
  }

  public getCgMidDesign(): string {
    return this.cgMidDesign;
  }

  public setCgMidDesign(value: string): void {
    this.cgMidDesign = value;
  }

  public getPaymentSuccessURL(): string {
    return this.paymentSuccessURL;
  }

  public setPaymentSuccessURL(value: string): void {
    this.paymentSuccessURL = value;
  }

  public getPaymentErrorURL(): string {
    return this.paymentErrorURL;
  }

  public setPaymentErrorURL(value: string): void {
    this.paymentErrorURL = value;
  }

  public setStateId(value: number): void {
    this.stateId = value;
  }

  public getStateId(): number {
    return this.stateId || 0;
  }

  public setBrokerFee(value: number): void {
    this.brokerFee = value;
  }

  public getBrokerFee(): number {
    return this.brokerFee || 0.0;
  }

  public setSelectInsuredAmountId(value: number): void {
    this.selectedInsuredAmountId = value;
  }

  public getSelectInsuredAmountId(): number {
    return this.selectedInsuredAmountId;
  }

  public getQuestionnaireId(): number {
    return this.questionnaireId;
  }

  public setQuestionnaireId(value: number): void {
    this.questionnaireId = value;
  }
}

class Owner {
  private type: number;
  private participantNum: number;
  private customerID: string;
  private leadID: number;
  private medicalFormID: number;
  private isCustomerExists: boolean;
  private personalID: string;
  private uniqueMedicalID: string;
  private title: string;
  private firstName: string;
  private surName: string;
  private agentFlowName: string;
  private email: string;
  private phoneNumber: string;
  private phonePrefix: string;
  private dateOfBirth: string;
  private age: number;
  private isApotropos: boolean;
  private englishFirstName: string;
  private englishLastName: string;
  private isSelected: boolean;
  private isEditMode: boolean;
  private coversIds: number[];
  private phoneModel: string;
  private disclaimer: string | null;
  private allowMarketingMaterial: boolean | null;
  private computerModel: string | null;
  private takePhone: boolean;
  private deliveryAddressAutocomplete: null;
  private billingAddressAutocomplete: null;

  public getType(): number {
    return this.type;
  }

  public setType(value: number): void {
    this.type = value;
  }

  public getparticipantNum(): number {
    return this.participantNum;
  }

  public setparticipantNum(value: number): void {
    this.participantNum = value;
  }

  public getCustomerID(): string {
    return this.customerID;
  }

  public setCustomerID(value: string): void {
    this.customerID = value;
  }

  public getLeadID(): number {
    return this.leadID;
  }

  public setLeadID(value: number): void {
    this.leadID = value;
  }

  public getMedicalFormID(): number {
    return this.medicalFormID;
  }

  public setMedicalFormID(value: number): void {
    this.medicalFormID = value;
  }

  public getIsCustomerExists(): boolean {
    return this.isCustomerExists;
  }

  public setIsCustomerExists(value: boolean): void {
    this.isCustomerExists = value;
  }

  public getPersonalID(): string {
    return this.personalID;
  }

  public setPersonalID(value: string): void {
    this.personalID = value;
  }

  public getUniqueMedicalID(): string {
    return this.uniqueMedicalID;
  }

  public setUniqueMedicalID(value: string): void {
    this.uniqueMedicalID = value;
  }

  public getTitle(): string {
    return this.title;
  }

  public setTitle(value: string): void {
    this.title = value;
  }

  public getFirstName(): string {
    return this.firstName;
  }

  public setFirstName(value: string): void {
    this.firstName = value;
  }

  public getSurName(): string {
    return this.surName;
  }

  public setSurName(value: string): void {
    this.surName = value;
  }

  public getAgentFlowName(): string {
    return this.agentFlowName;
  }

  public setAgentFlowName(value: string): void {
    this.agentFlowName = value;
  }

  public getEmail(): string {
    return this.email;
  }

  public setEmail(value: string): void {
    this.email = value;
  }

  public getPhoneNumber(): string {
    return this.phoneNumber;
  }

  public setPhoneNumber(value: string): void {
    this.phoneNumber = value;
  }

  public getPhonePrefix(): string {
    return this.phonePrefix;
  }

  public setPhonePrefix(value: string): void {
    this.phonePrefix = value;
  }

  public getDateOfBirth(): string {
    return this.dateOfBirth;
  }

  public setDateOfBirth(value: string): void {
    this.dateOfBirth = value;
  }

  public getAge(): number {
    return this.age;
  }

  public setAge(value: number): void {
    this.age = value;
  }

  public getIsApotropos(): boolean {
    return this.isApotropos;
  }

  public setIsApotropos(value: boolean): void {
    this.isApotropos = value;
  }

  public getEnglishFirstName(): string {
    return this.englishFirstName;
  }

  public setEnglishFirstName(value: string): void {
    this.englishFirstName = value;
  }

  public getEnglishLastName(): string {
    return this.englishLastName;
  }

  public setEnglishLastName(value: string): void {
    this.englishLastName = value;
  }

  public getIsSelected(): boolean {
    return this.isSelected;
  }

  public setIsSelected(value: boolean): void {
    this.isSelected = value;
  }

  public getIsEditMode(): boolean {
    return this.isEditMode;
  }

  public setIsEditMode(value: boolean): void {
    this.isEditMode = value;
  }

  public getCoversIds(): number[] {
    return this.coversIds;
  }

  public setCoversIds(value: number[]): void {
    this.coversIds = value;
  }

  public getPhoneModel(): string {
    return this.phoneModel;
  }

  public setPhoneModel(value: string): void {
    this.phoneModel = value;
  }

  public getDisclaimer(): string | null {
    return this.disclaimer;
  }

  public setDisclaimer(value: string | null): void {
    this.disclaimer = value;
  }

  public getAllowMarketingMaterial(): boolean | null {
    return this.allowMarketingMaterial;
  }

  public setAllowMarketingMaterial(value: boolean | null): void {
    this.allowMarketingMaterial = value;
  }

  public getComputerModel(): string | null {
    return this.computerModel;
  }

  public setComputerModel(value: string | null): void {
    this.computerModel = value;
  }

  public getTakePhone(): boolean {
    return this.takePhone;
  }

  public setTakePhone(value: boolean): void {
    this.takePhone = value;
  }

  public getDeliveryAddressAutocomplete(): null {
    return this.deliveryAddressAutocomplete;
  }

  public setDeliveryAddressAutocomplete(value: null): void {
    this.deliveryAddressAutocomplete = value;
  }

  public getBillingAddressAutocomplete(): null {
    return this.billingAddressAutocomplete;
  }

  public setBillingAddressAutocomplete(value: null): void {
    this.billingAddressAutocomplete = value;
  }
}
